/*
 * Basic file with global javascript.
 * Files imported here will be available on every page.
 */

import '../../utils/swiper';

import Alpine from 'alpinejs';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';

import '~/styles/main.css'; // tailwind
import '~/styles/custom.css'; // custom CSS

import React from 'react';
import { createRoot } from 'react-dom/client';
import CartDrawer from '../snippets/cart-drawer/cart-drawer';

/** Global Scripts */
import xOnShopify from '~js/alpine-plugins/x-on-shopify';
import { QuickAddProductSideDrawer } from '~js/bundles/snippets/side-drawer';
import Header from '../sections/header';
import MobileMenuOverlay from '../snippets/mobile-menuoverlay';
import { handleQuickBuyClickGlobal } from '../snippets/quick-add-to-bag-global';
import {
  initFooterCountrySelector,
  initFooterMenuAccordions,
} from '../sections/footer';
import { initHeroSwiper } from '../sections/hero';

/** Product Detail Page Scripts */
import { QuickAddProductDrawerMobile } from '../snippets/pdp-mobile-drawer';

/** Components */
import { initProductTabScript } from '../sections/product-tab';
import { initReviewsScript } from '../sections/reviews';
import { initSocialMediaScript } from '../sections/social-media';
import { initSimpleAccordions } from '~js/bundles/snippets/simple-accordion';
import { tabs } from '~js/bundles/sections/tabs';

/** Blogs & Articles */
// import BlogsSection from '../sections/blog';
// import BlogCarouselSection from '../sections/blogs-carousel-section';
// import BlogArchiveSection from '../sections/blog-archive-section';

/** Customer */
import CustomerLogin from '../sections/customer-login';
import { initSpotlightScript } from '../sections/spotlight';

// Global Config
window.globalConfig = {
  currency: window.Shopify?.currency?.active || 'USD',
  localeCode:
    window.Shopify?.locale && window.Shopify?.country
      ? `${window.Shopify.locale}-${window.Shopify.country}`
      : 'en-US',
};

/** Global Components */
QuickAddProductSideDrawer.initialize();
initHeroSwiper();
Header.initializeEvents();
MobileMenuOverlay.init();
handleQuickBuyClickGlobal();
QuickAddProductDrawerMobile.initialize();
initFooterMenuAccordions();
initFooterCountrySelector();
initProductTabScript();
initReviewsScript();
initSocialMediaScript();
initSimpleAccordions();
tabs.init();
initSpotlightScript();

/** Customer */
CustomerLogin.init();

/** React Components */
const reactAppsMapping = {
  'cart-drawer': CartDrawer,
};

document.addEventListener('DOMContentLoaded', () => {
  const reactApps = document.querySelectorAll('.react-app-root');

  reactApps.forEach((container) => {
    const appId = container.id;
    const Component = reactAppsMapping[appId];

    if (Component) {
      const root = createRoot(container); // Create a root
      root.render(<Component />); // Render the component
    }
  });
});

Alpine.plugin(xOnShopify);

window.Alpine = Alpine;
Alpine.start();

// // BUGHERD
if (
  window.location.hostname !== '127.0.0.1' &&
  !window.Shopify.designMode &&
  window.Shopify.theme.role !== 'main'
) {
  const script = document.createElement('script');
  script.src =
    'https://www.bugherd.com/sidebarv2.js?apikey=czwfalkp21nfn9k6j07x4q';
  document.head.append(script);
}
